(function () {
  'use strict';

  function parseJson(node) {
    if (!node) return {};
    try { return JSON.parse(node.textContent); } catch (error) { return {}; }
  }

  function init(root) {
    if (root.dataset.c45AccessoriesReady === 'true') return;
    root.dataset.c45AccessoriesReady = 'true';

    var form = root.querySelector('#c45-product-form');
    var idInput = root.querySelector('[data-c45-variant-id]');
    var priceNode = root.querySelector('[data-c45-price]');
    var submit = root.querySelector('[data-c45-submit]');
    var status = root.querySelector('[data-c45-status]');
    var visorLayer = root.querySelector('[data-c45-visor-layer]');
    var sideLayer = root.querySelector('[data-c45-side-layer]');
    var visorLabel = root.querySelector('[data-c45-visor-label]');
    var sideLabel = root.querySelector('[data-c45-side-label]');
    var visorStock = root.querySelector('[data-c45-visor-stock]');
    var sideStock = root.querySelector('[data-c45-side-stock]');
    var helmetStock = root.querySelector('[data-c45-helmet-stock]');
    var leadTime = root.querySelector('[data-c45-lead-time]');
    var sidePanel = root.querySelector('[data-c45-side-design-panel]');
    var copy = parseJson(root.querySelector('[data-c45-copy]'));
    var variants = parseJson(root.querySelector('[data-c45-variants]'));
    if (!form || !idInput || !submit || !Array.isArray(variants)) return;

    var accordionSteps = Array.prototype.slice.call(root.querySelectorAll('[data-c45-step]'));
    var orderGrid = root.querySelector('.sds-c45__order-grid');
    var previewCard = root.querySelector('.sds-c45__preview-card');
    var sizeChartLink = root.querySelector('[data-c45-size-chart]');
    var mobileAccordion = window.matchMedia('(max-width: 900px)');
    var accordionModeChanging = false;
    var accordionName = (root.id || 'c45-configurator') + '-options';

    function syncAccordionState() {
      var editing = mobileAccordion.matches && accordionSteps.some(function (step) { return step.open; });
      if (orderGrid) orderGrid.classList.toggle('is-config-editing', editing);
    }

    function applyAccordionMode() {
      accordionModeChanging = true;
      accordionSteps.forEach(function (step) {
        var stepSummary = step.querySelector('summary');
        if (mobileAccordion.matches) {
          step.setAttribute('name', accordionName);
          step.open = false;
          if (stepSummary) stepSummary.removeAttribute('tabindex');
        } else {
          step.removeAttribute('name');
          step.open = true;
          if (stepSummary) stepSummary.setAttribute('tabindex', '-1');
        }
      });
      if (mobileAccordion.matches && accordionSteps[0]) accordionSteps[0].open = true;
      window.requestAnimationFrame(function () {
        accordionModeChanging = false;
        syncAccordionState();
      });
    }

    accordionSteps.forEach(function (step) {
      var stepSummary = step.querySelector('summary');
      if (stepSummary) {
        stepSummary.addEventListener('click', function (event) {
          var isSizeChartLink = event.target.closest && event.target.closest('[data-c45-size-chart]');
          if (!mobileAccordion.matches && !isSizeChartLink) event.preventDefault();
        });
      }
      step.addEventListener('toggle', function () {
        if (accordionModeChanging) return;
        if (mobileAccordion.matches && step.open) {
          accordionSteps.forEach(function (other) {
            if (other !== step && other.open) other.open = false;
          });
          window.requestAnimationFrame(function () {
            if (previewCard) {
              var previewTop = window.scrollY + previewCard.getBoundingClientRect().top - 8;
              window.scrollTo(0, Math.max(0, previewTop));
            }
            syncAccordionState();
          });
          return;
        } else if (!mobileAccordion.matches && !step.open) {
          step.open = true;
        }
        window.requestAnimationFrame(syncAccordionState);
      });
    });
    if (mobileAccordion.addEventListener) mobileAccordion.addEventListener('change', applyAccordionMode);
    else mobileAccordion.addListener(applyAccordionMode);
    if (sizeChartLink) {
      sizeChartLink.addEventListener('click', function (event) {
        var target = document.querySelector(sizeChartLink.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        event.stopPropagation();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (window.history && window.history.pushState) window.history.pushState(null, '', sizeChartLink.getAttribute('href'));
      });
    }
    applyAccordionMode();

    function money(cents) {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR'
      }).format(cents / 100);
    }

    function selectedVisor() {
      return root.querySelector('input[name="c45_visor"]:checked');
    }

    function selectedSide() {
      return root.querySelector('[data-c45-side-option].is-active');
    }

    function setLayer(layer, source, opacity) {
      if (!layer) return;
      if (source) {
        if (layer.src !== source) layer.src = source;
        layer.style.opacity = String(opacity == null ? 1 : opacity);
        layer.hidden = false;
      } else {
        layer.hidden = true;
        layer.style.opacity = '1';
        layer.removeAttribute('src');
      }
    }

    function currentHelmetVariant() {
      var id = String(idInput.value || '');
      return variants.find(function (variant) { return String(variant.id) === id; });
    }

    function stockStateForVariant(variant) {
      if (!variant) return 'unavailable';
      if (variant.stock_state) return variant.stock_state;
      var tracked = Boolean(variant.inventory_management);
      var quantity = Number(variant.inventory_quantity || 0);
      var policy = String(variant.inventory_policy || '').toLowerCase();
      if (tracked && quantity <= 0) {
        return policy === 'continue' && variant.available !== false ? 'preorder' : 'unavailable';
      }
      return variant.available === false ? 'unavailable' : 'in-stock';
    }

    function updateStockBadge(node, state) {
      if (!node) return;
      var labels = {
        'in-stock': copy.stockInStock || 'In Stock',
        preorder: copy.stockPreorder || 'Pre-Order',
        included: copy.stockIncluded || 'Included',
        unavailable: copy.unavailableShort || 'Unavailable'
      };
      node.dataset.stockState = state;
      node.classList.remove('is-in-stock', 'is-preorder', 'is-included', 'is-unavailable');
      node.classList.add('is-' + state);
      node.textContent = labels[state] || labels.unavailable;
    }

    function refreshAccessories() {
      var visor = selectedVisor();
      var side = selectedSide();
      var helmet = currentHelmetVariant();
      var visorPrice = visor ? Number(visor.dataset.priceCents || 0) : 0;
      var sidePrice = side ? Number(side.dataset.priceCents || 0) : 0;
      var helmetPrice = helmet ? Number(helmet.price || 0) : 0;
      var helmetStockState = stockStateForVariant(helmet);
      var visorStockState = visor && visor.dataset.stockState ? visor.dataset.stockState : 'included';
      var sideStockState = side && side.dataset.stockState ? side.dataset.stockState : 'included';

      root.querySelectorAll('[data-c45-visors] .sds-c45__accessory-card').forEach(function (card) {
        var input = card.querySelector('input');
        card.classList.toggle('is-active', Boolean(input && input.checked));
      });

      if (visorLabel && visor) visorLabel.textContent = visor.dataset.label || copy.visorNone || 'Included clear visor';
      if (sideLabel) sideLabel.textContent = side && side.dataset.label ? side.dataset.label : (copy.sideplateStandard || 'Standard');
      updateStockBadge(helmetStock, helmetStockState);
      updateStockBadge(visorStock, visorStockState);
      updateStockBadge(sideStock, sideStockState);
      if (leadTime) leadTime.hidden = ![helmetStockState, visorStockState, sideStockState].some(function (state) { return state === 'preorder'; });
      setLayer(visorLayer, visor && visor.dataset.previewSrc ? visor.dataset.previewSrc : '', visor && visor.dataset.previewOpacity ? Number(visor.dataset.previewOpacity) : 1);
      setLayer(sideLayer, side && side.dataset.previewSrc ? side.dataset.previewSrc : '', 1);

      if (priceNode && helmetPrice > 0) priceNode.textContent = money(helmetPrice + visorPrice + sidePrice);
      if (status && !submit.disabled) status.textContent = '';
    }

    root.querySelectorAll('input[name="c45_visor"]').forEach(function (input) {
      input.addEventListener('change', refreshAccessories);
    });

    function activateSideOption(button) {
      root.querySelectorAll('[data-c45-side-option]').forEach(function (option) {
        var active = option === button;
        option.classList.toggle('is-active', active);
        option.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      refreshAccessories();
    }

    root.querySelectorAll('[data-c45-side-colors] [data-side-color]').forEach(function (button) {
      button.addEventListener('click', function () {
        var color = button.dataset.sideColor || '';
        root.querySelectorAll('[data-c45-side-colors] [data-side-color]').forEach(function (colorButton) {
          var active = colorButton === button;
          colorButton.classList.toggle('is-active', active);
          colorButton.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        var options = Array.prototype.slice.call(root.querySelectorAll('[data-c45-side-option]'));
        options.forEach(function (option) {
          option.hidden = !color || option.dataset.color !== color;
          option.classList.remove('is-active');
          option.setAttribute('aria-pressed', 'false');
        });

        if (!color) {
          if (sidePanel) sidePanel.hidden = true;
          refreshAccessories();
          return;
        }

        if (sidePanel) sidePanel.hidden = false;
        var matching = options.filter(function (option) { return option.dataset.color === color && !option.disabled; });
        var preferred = matching.find(function (option) { return option.dataset.design === 'c45'; }) || matching[0] || null;
        activateSideOption(preferred);
      });
    });

    root.querySelectorAll('[data-c45-side-option]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (!button.disabled) activateSideOption(button);
      });
    });

    root.querySelectorAll('[data-c45-colors] button,[data-c45-sizes] button').forEach(function (button) {
      button.addEventListener('click', refreshAccessories);
    });

    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (submit.disabled) return;

      var helmet = currentHelmetVariant();
      if (!helmet) {
        if (status) status.textContent = copy.unavailableCombo || 'This combination is not available.';
        return;
      }

      var visor = selectedVisor();
      var side = selectedSide();
      var color = root.querySelector('[data-c45-color-label]');
      var size = root.querySelector('[data-c45-size-label]');
      var configCode = 'C45-' + Date.now().toString(36).toUpperCase();
      var items = [{
        id: Number(helmet.id),
        quantity: 1,
        properties: {
          _c45_config_code: configCode,
          _c45_role: 'helmet',
          _c45_finish: color ? color.textContent.trim() : '',
          _c45_size: size ? size.textContent.trim() : ''
        }
      }];

      if (visor && visor.value) {
        items.push({
          id: Number(visor.value),
          quantity: 1,
          properties: {
            _c45_parent_config: configCode,
            _c45_role: 'visor',
            _c45_option: visor.dataset.label || ''
          }
        });
      }
      if (side && side.dataset.variantId) {
        items.push({
          id: Number(side.dataset.variantId),
          quantity: 1,
          properties: {
            _c45_parent_config: configCode,
            _c45_role: 'side_plates',
            _c45_option: side.dataset.label || ''
          }
        });
      }

      var originalText = submit.textContent;
      submit.disabled = true;
      submit.textContent = copy.addingToCart || 'Adding to cart…';
      if (status) status.textContent = '';

      try {
        var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        var response = await fetch(rootPath + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        });
        if (!response.ok) {
          var payload = await response.json().catch(function () { return {}; });
          throw new Error(payload.description || payload.message || ('Cart API returned ' + response.status));
        }
        window.location.assign(rootPath + 'cart');
      } catch (error) {
        submit.disabled = false;
        submit.textContent = originalText;
        if (status) status.textContent = (copy.cartError || 'We could not add this build to the cart.') + ' ' + (error && error.message ? error.message : '');
      }
    });

    refreshAccessories();
  }

  document.querySelectorAll('[data-c45-root]').forEach(init);
})();
